import styled from "styled-components"
import { colors, fontWeight, scale, breakpoint } from "../../styles"
import { display } from "styled-system"

export const SecondaryMenuListStyled = styled.ul`
	display: flex;
	width: 100%;
	align-items: center;

	${breakpoint("l")`
		column-gap: ${scale.px(8)};
	`}
`

export const SecondaryMenuItemStyled = styled.li`
	position: relative;
	align-items: center;
	${display}

	&:after {
		content: "";
		position: absolute;
		bottom: ${scale.px(-1.5)};
		left: 0;
		width: 100%;
		height: 2px;
		background-color: ${colors["navy"]};
		visibility: hidden;
		transform: scaleX(0);
		transition: all 0.1s ease-in-out;
	}

	&:hover,
	&.active {
		&:after {
			visibility: visible;
			transform: scaleX(1);
		}
	}

	&.active {
		font-weight: ${fontWeight["bold"]};
	}
`
